import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import store from '../../reduxStore';
import { actions, event } from '../../model';
import updateAllChips from '../../utils/updateAllChips';

let index = 0;

class Chip extends React.PureComponent {
    static propTypes = {
        content: PropTypes.any,
        id: PropTypes.string,
        type: PropTypes.string,
        position: PropTypes.string,
        title: PropTypes.string,
        groupName: PropTypes.string,
        translate: PropTypes.string,
        translateOptions: PropTypes.object,
        children: PropTypes.element,
        user: PropTypes.string,
        name: PropTypes.string,
        code: PropTypes.string,
    };

    state = {
        originContent: this.props.content,
        content: this.props.content,
        useErrorPlaceholder: false,
    };

    elm = React.createRef();

    index = index++;

    // 每次创建碎片，都会生成一个唯一id，以免在一个页面中存在id类型都一样的碎片。
    uid = `${this.props.type}_${this.props.id}_${this.index}`;

    updateData() {
        const {
            id,
            type,
            position = 'absolute',
            title,
            groupName,
            translate = '',
            translateOptions = null,
            user = 'editor',
            name = '',
            code = '',
        } = this.props;
        const elm = ReactDOM.findDOMNode(this.elm.current);
        const rect = elm.getBoundingClientRect();
        const p = {
            top: rect.top + document.documentElement.scrollTop,
            left: rect.left + document.documentElement.scrollLeft,
            height: rect.height,
            width: rect.width,
        };

        // 通过data-attribute将碎片信息和dom对应起来
        elm.dataset.__chipTarget = this.uid;

        return {
            index: this.index,
            uid: this.uid,
            id,
            type,
            title,
            groupName,
            translate,
            translateOptions,
            position,
            key: name,
            user,
            code,
            rect: p,
        };
    }
    componentDidMount() {
        const { id, type } = this.props;
        const elm = ReactDOM.findDOMNode(this.elm.current);

        this.offChipUpdateEvent = event.on(`chip_${type}_${id}_${this.index}_update`, ({ data, action }) => {
            // 重新给content赋值时，需要清除掉占位dom，是碎片能够重新进行渲染（当然也可能渲染错误，再次使用占位碎片）
            switch (action) {
                case 'preview':
                    this.setState({ useErrorPlaceholder: true });
                    setTimeout(() => {
                        this.setState({ content: data, useErrorPlaceholder: false });
                    }, 20);
                    break;
                case 'save':
                    this.setState({ useErrorPlaceholder: true });
                    setTimeout(() => {
                        this.setState({ content: data, originContent: data, useErrorPlaceholder: false });
                    }, 20);
                    break;
                case 'cancle':
                    this.setState({ useErrorPlaceholder: true });
                    setTimeout(() => {
                        this.setState({ content: this.state.originContent, useErrorPlaceholder: false });
                    }, 20);
                    break;
                default:
                    break;
            }
        });
        // 判断碎片的dom是否存在（如果碎片渲染错误，就不会生成dom），这个时候需要自己创建一个占位dom，保证碎片能创建出来，让编辑有机会去修正数据
        if (elm) {
            store.dispatch(actions.chipsAdd(this.updateData()));
        } else {
            // 完成占位dom创建后，再去增加碎片数据。
            this.setState(
                {
                    useErrorPlaceholder: true,
                },
                () => {
                    store.dispatch(actions.chipsAdd(this.updateData()));
                },
            );
        }
    }
    componentWillUnmount() {
        console.log('chip componentWillUnmount');
        this.offChipUpdateEvent();
        store.dispatch(actions.chipsDel(this.uid));
        updateAllChips();
    }

    // 对碎片进行预览，保存，取消的操作的时候，需要再次对dom进行判断，避免出现修改数据过程中出现错误导致页面崩溃。
    componentDidUpdate() {
        const elm = ReactDOM.findDOMNode(this.elm.current);

        if (!elm) {
            this.setState({
                useErrorPlaceholder: true,
            });
        } else {
            // 将 uid 重新赋值给碎片的dom，避免由于碎片或者占位dom重新创建时，没有该data-attribute，导致碎片无法跟蒙层对应上
            elm.dataset.__chipTarget = this.uid;
            // console.log('componentDidUpdate', this.uid);
            updateAllChips();
            // store.dispatch(actions.allChipsUpdate());
        }
    }

    componentDidCatch() {
        this.setState({
            useErrorPlaceholder: true,
        });
    }
    render() {
        const { children } = this.props;
        const { useErrorPlaceholder } = this.state;

        // 通过对使用占位节点来保证碎片渲染错误是能够显示碎片蒙层
        if (useErrorPlaceholder) {
            return (
                <div
                    ref={this.elm}
                    style={{
                        height: 30,
                        color: '#fff',
                        backgroundColor: 'red',
                        lineHeight: '30px',
                        textAlign: 'center',
                        fontSize: '12px',
                    }}>
                    数据错误，渲染失败
                </div>
            );
        } else {
            const childrenWithProps = React.Children.map(children, child =>
                React.cloneElement(child, { content: this.state.content, ref: this.elm }),
            );

            return [childrenWithProps];
        }
    }
}

export default Chip;
